import { SETTINGS } from '@/constants/settings'

export function addTokenToUrl(link: string): string {
  const url: URL = new URL(link)
  url.searchParams.set('token', localStorage.getItem(SETTINGS.AUTH.TOKEN_NAME) ?? '')
  return url.toString()
}
